export const mapPackagingTypeTypeToApi = ({
  packagingType,
  skuType,
  labelPurchaseType,
  originAddress,
  products,
  id
}) => {
  return {
    data: {
      ShippingTypeId: packagingType.id,
      ShippingTypeName: typeof packagingType.name === 'string' ? packagingType.name : packagingType.name.Name,
      SKUTypeId: skuType.id,
      IsShipBobLabels: !products.some(x => x.isDangerousGoods === true) && labelPurchaseType.id === 1,
      Address: labelPurchaseType.id === 1 && originAddress ? {
        name: originAddress.name,
        streetAddress1: originAddress.streetAddress1,
        streetAddress2: originAddress.streetAddress2,
        city: originAddress.city,
        state: originAddress.state,
        zipCode: originAddress.zipCode,
        country: 'USA'
      } : null
    },
    id
  }
}

export const mapAddressToValidationApi = ({
  name,
  streetAddress1,
  streetAddress2,
  city,
  state,
  country,
  zipCode
}) => {
  return {
    name,
    street1: streetAddress1,
    street2: streetAddress2,
    city,
    state,
    country: 'USA',
    zip: zipCode
  }
}
